import React, { Component } from "react"
import styled from "styled-components"
import { easeOutCubic } from "js-easing-functions"

import PropTypes from "prop-types"

import * as vars from '../style/vars'

const scale = (width, chars) => (width / 300) * (5 + 1 / chars)

class FadeCounter extends Component {
  constructor() {
    super();

    this.fadeCounterRef = React.createRef();
    this.state = {
      number: 0,
      startTime: 0,
      isStarted: false,
      width: 1
    };
  }

  componentDidMount() {
    this.setState({ number: this.props.from });
    this.resize();

    // Give things time to settle before we kick this into gear
    setTimeout(() => this.checkElementPosition(), 500)

    window.addEventListener('scroll', this.scroll.bind(this));
    window.addEventListener('resize', this.resize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scroll.bind(this));
    window.removeEventListener('resize', this.resize.bind(this));
    cancelAnimationFrame( this.animation );
  }

  resize() {
    let el = this.fadeCounterRef.current;

    if (el) {
      this.setState({ width: el.parentElement.getBoundingClientRect().width })
    }
  }

  checkElementPosition() {
    let el = this.fadeCounterRef.current;
    if( !el ) 
      return

    // Wait until the element is visible to start animation
    let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    let top = el.getBoundingClientRect().top;
    let height = el.getBoundingClientRect().height;
    let isInViewport = windowHeight - top - height;

    if (isInViewport > 0 && !this.state.isStarted) {
      setTimeout(() => this.start(), this.props.delay)
    }
  }

  scroll() {
    this.checkElementPosition();
  }

  start() {
    this.setState({ isStarted: true });
    this.animation = requestAnimationFrame( this.count.bind(this) );
  }

  count(timestamp) {
    if (this.state.number === this.props.value) {
      return;
    }

    if (this.state.startTime === 0) {
      this.setState({ startTime: timestamp });
    }

    let progress = timestamp - this.state.startTime;

    if (this.props.from < this.props.value) {
      this.setState((prevState, props) => {
        return {
          number: easeOutCubic( progress, props.from, props.value, props.duration )
        }
      });
    }
    else {
      this.setState((prevState, props) => {
        return {
          number: props.from - easeOutCubic(progress, props.value, props.from, props.duration)
        }
      });
    }

    let isFinished = false;

    if ( this.props.from < this.props.value && this.state.number >= this.props.value ) {
      isFinished = true;
    }

    if (this.props.from > this.props.value && this.state.number <= this.props.value) {
      isFinished = true;
    }

    if (isFinished) {
      this.setState((prevState, props) => {
        return { number: this.props.value }
      });
      return cancelAnimationFrame( this.animation );
    }

    setTimeout(() => {
      this.animation = requestAnimationFrame( this.count.bind(this) );
    }, 40)
  }

  render() {
    const { value, format, delay, duration } = this.props;

    return (
      <FadeCounterWrapper
        duration={ duration }
        className={ this.state.isStarted ? 'is-transitioning' : '' }
        count={format(value).length}
        width={this.state.width}
        style={{ transitionDelay: delay + "ms" }}
        innerRef={this.fadeCounterRef}>
          { format(this.state.number) }
      </FadeCounterWrapper>
    );
  }
}

// @NOTE: temporary styling - please feel free to remove/adjust!
const FadeCounterWrapper = styled.span`
  color: ${vars.colors.body};
  font-family: ${vars.fonts.header};
  font-size: ${props => scale(props.width, props.count)}rem;
  display: block;
  letter-spacing: 0.2rem;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity ${props => props.duration}ms ${vars.easings.easeOutQuint}, transform ${props => props.duration}ms ${vars.easings.easeOutQuint};

  &.is-transitioning {
    opacity: 1;
    transform: translateY(0);
  }
`

FadeCounter.propTypes = {
  value: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  format: PropTypes.func.isRequired,
  delay: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired
}

FadeCounter.defaultProps = {
  from: 0,
  delay: 0,
  duration: 3000
}



export default FadeCounter
